import { Button } from '@chakra-ui/react';
import Error from '@core/components/Error/Error';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const Error500 = (): React.ReactElement | null => {
  const { t } = useTranslation();
  return (
    <Error
      title={t('error.defaultTitle')}
      description={<>{t('error.defaultDescription')}.</>}
      logo
      actions={
        <Button
          className="refresh"
          colorScheme="red"
          variant="solid"
          size="sm"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('global.refreshPage')}
        </Button>
      }
    />
  );
};

export default Error500;
